<script>
export default {
    name: "select-field",
    props: {
        autocomplete: {
            type: Boolean
        }
    }
}
</script>

<template>
    <v-select v-if="!autocomplete"
              v-bind="$attrs"
              @input="$emit('input', $event)"
              outlined
              dense
    />
    <v-autocomplete v-else
                    v-bind="$attrs"
                    @input="$emit('input', $event)"
                    outlined
                    dense
    />
</template>

<style>
    .v-select__slot label {
        font-weight: 400;
    }
</style>
